import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import {
  PureBiData,
  BiEvent,
  VideoPlayerActionBiEvent,
} from '@wix/da-bi/pkg/events';
import { getPublicSession } from '../../../publicSession/selectors';

export type VideoPlayerAction =
  | 'play'
  | 'pause'
  | 'timeupdate'
  | 'volumechange'
  | 'sourcechange'
  | 'enterfullscreen'
  | 'exitfullscreen'
  | 'ended';

export function useVideoPlayerActionBiLogger(
  deviation: PapiDeviation
): (action: VideoPlayerAction) => void {
  const publicSession = useSelector(getPublicSession, () => true);

  return useCallback(
    (action: VideoPlayerAction) => {
      const event: BiEvent = PureBiData<VideoPlayerActionBiEvent>({
        evid: 311,
        deviationid: deviation.deviationId,
        action,
      });

      biLogger.log(publicSession, event);
    },
    [deviation.deviationId, publicSession]
  );
}
